import { Container, Row, Title, Span } from "./Metrics.styled";
import { IMetricsProps } from "./Metrics.types";

export function Metrics({ title, metrics }: IMetricsProps) {
  return (
    <Container>
      <Title>{title}</Title>
      {metrics.map((metric) => (
        <Row>
          {metric.bold ? (
            <Span>
              <strong>{metric.label}</strong>
            </Span>
          ) : (
            <Span>{metric.label}</Span>
          )}
          <Span>
            <strong>{metric.value}</strong>
          </Span>
        </Row>
      ))}
    </Container>
  );
}
